export default __webpack_public_path__ + "static/media/Terms_Conditions_of_Sale.663ba2b2.pdf";